import { SyncEmail } from "types/sync_email";

const BLOCK_TAGS = new Set([
  "P", "DIV", "BR", "LI", "TR", "H1", "H2", "H3", "H4", "H5", "H6",
  "BLOCKQUOTE", "PRE", "TABLE", "UL", "OL", "HR", "SECTION", "ARTICLE",
]);
const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "HEAD", "TITLE"]);

/** Flatten an HTML email body into readable plain text (browser DOMParser). */
export function htmlToText(html: string | undefined | null): string {
  if (!html || typeof DOMParser === "undefined") return "";
  let doc: Document;
  try {
    doc = new DOMParser().parseFromString(html, "text/html");
  } catch {
    return html.replace(/<[^>]+>/g, " ").trim();
  }
  const chunks: string[] = [];
  const walk = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      chunks.push(node.textContent || "");
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const tag = (node as Element).tagName;
    if (SKIP_TAGS.has(tag)) return;
    if (tag === "BR") {
      chunks.push("\n");
      return;
    }
    node.childNodes.forEach(walk);
    if (BLOCK_TAGS.has(tag)) chunks.push("\n");
  };
  walk(doc.body);
  return chunks
    .join("")
    .replace(/\r/g, "")
    .replace(/ /g, " ")
    .split("\n")
    .map((l) => l.trim())
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

/**
 * Plain-text body of an inbox email. Falls back to a flattened ``body_html``
 * for HTML-only messages (e.g. iOS Mail replies) whose ``body_text`` is empty.
 */
export function getEmailBodyText(email: Pick<SyncEmail, "body_text" | "body_html">): string {
  const text = email.body_text?.trim();
  if (text) return text;
  return htmlToText(email.body_html);
}
